import { Injectable } from '@angular/core';
import {Reason} from "../entities/reason";
import {PBReason, PBSaved, PBSelectUser, PocketbaseService} from "./pocketbase.service";
import {Router} from "@angular/router";

@Injectable({
  providedIn: 'root'
})
export class ReasonService {
  constructor(private pocket: PocketbaseService, private router: Router) {
  }

  getUser(){
    return this.pocket.getUser()
  }

  async getUserById(id: String) {
    const users = await this.pocket.getAllUser();
    return users.find(user => user.id === id);
  }

  async getTopic(id: String) {
    const topics = await this.pocket.getAllTopics();
    return topics.find(topic => topic.id === id);
  }

  getReason(id: String): Promise<PBReason> {
    return this.pocket.pb.collection('reason').getFirstListItem(`id="${id}"`);
  }

  getAllReasons(): Promise<Array<PBReason>> {
    return this.pocket.pb.collection('reason').getFullList({
      sort: '-topic'
    });
  }

  isReasonFromMe(reason: PBReason) : Boolean{
    return reason.createdFrom === this.pocket.pb.authStore.record?.id;
  }

  async isSaved(reason: PBReason): Promise<Boolean> {
    const reasons = await this.getSavedReasons();
    return reasons.some(savedReason => savedReason.reason.some(savededReason => savededReason === reason.id));
  }

  async getReasonsCreatedFromMe() : Promise<PBReason[]> {
    let reasons = await this.getAllReasons();
    return reasons.filter(reason => reason.createdFrom === this.pocket.pb.authStore.record?.id);
  }

  async getReasonsForMe():Promise<PBReason[]> {
    let reasons = await this.getAllReasons();
    return reasons.filter(reason => reason.forUser === this.pocket.pb.authStore.record?.id);
  }

  async postReason(reason: Reason, user: PBSelectUser){
    if (user.username === "Jeder"){
      this.pocket.getAllUser().then(p=>{
        p.forEach(async userI=>{
          const data = {
            "title": reason.title,
            "description": reason.description,
            "topic": reason.topic,
            "forUser": userI.id,
            "createdFrom": this.pocket.pb.authStore.record?.id
          };
          await this.pocket.pb.collection('reason').create(data);
        })
      })
    } else {
      const data = {
        "title": reason.title,
        "description": reason.description,
        "topic": reason.topic,
        "forUser": user.id,
        "createdFrom": this.pocket.pb.authStore.record?.id
      };
      await this.pocket.pb.collection('reason').create(data);

    }
  }

  async saveReason(id: String) {
    const p = await this.pocket.pb.collection('saved').getFullList();
    let reasons = [];
    p.forEach(sav => {
      reasons.push(sav.reason);
    });
    reasons.push(id);
    const data = {
      "reason": reasons,
      "user": this.pocket.pb.authStore.record?.id
    };
    this.pocket.pb.collection('saved').create(data)
      .then()
      .catch(err => {
        console.log(err);
      });
  }

  getSavedReasons():Promise<Array<PBSaved>>{
    return this.pocket.pb.collection('saved').getFullList()
  }

  openReason(id: String){
    this.router.navigate(["/reason/", id]);
  }

  async updateReason(reasonId: String, title: String, description: String, topic: String, pbSelectUser: PBSelectUser) {
    const data = {
      "title": title,
      "description": description,
      "topic": topic,
      "forUser": pbSelectUser.id
    };
    return await this.pocket.pb.collection('reason').update(reasonId as string, data)
  }
}
